import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@hta/auth';
import { of, switchMap } from 'rxjs';

/**
 * Helper function to check if a cookie exists
 */
function hasCookie(name: string): boolean {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.indexOf(nameEQ) === 0) {
            return true;
        }
    }
    return false;
}

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    const isLoggedIn = inject(AuthService).isAuthenticated();
    
    if (isLoggedIn === true) {
        // User is already logged in, check if tenant is selected
        const hasTenantCookie = hasCookie('.hta_tenant_session');
        
        if (!hasTenantCookie) {
            // No tenant selected, redirect to tenant selection
            return of(router.parseUrl('/tenant-selection'));
        }
        
        // Tenant selected, redirect to home page
        return of(router.parseUrl('/'));
    }
    
    return true;
};
